import React from 'react';
export function Footer() {
  return <footer className="bg-brand-dark text-gray-500 py-6 px-4 border-t-2 border-brand-accent/20" data-id="element-66">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-67">
        <div className="inline-block bg-brand-accent text-brand-dark font-black px-4 py-1.5 rounded-full mb-4 text-xs tracking-widest uppercase shadow-[0_0_15px_rgba(0,255,136,0.3)]" data-id="element-68">
          📜 KIT COMPLETO FILOSOFÍA LISTA
        </div>

        <div className="w-full pt-2 text-xs md:text-sm text-gray-400 font-bold uppercase tracking-wide" data-id="element-69">
          <p data-id="element-70">© 2025 Kit Filosofía Lista — Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
}